import Requestor from '@/api/Requestor';
import { clientInstance } from '@/api/core';
// https://dev-zoo-client-api.barogo.io/docs/api-guide.html#_5_11_%EC%A3%BC%EB%AC%B8_%EC%9D%B4%EB%B2%A4%ED%8A%B8_%EB%B0%9C%EC%83%9D_api
// const orderEventType = {
//   WORKER_REQUEST: 'WORKER_REQUEST',
//   WORKER_REJECT: 'WORKER_REJECT',
//   PRIORITY_ALLOCATE: 'PRIORITY_ALLOCATE',
//   PRIORITY_ALLOCATE_CANCEL: 'PRIORITY_ALLOCATE_CANCEL',
//   ALLOCATE: 'ALLOCATE',
//   ALLOCATE_CANCEL: 'ALLOCATE_CANCEL',
//   REALLOCATE: 'REALLOCATE',
//   PICKUP_ARRIVE: 'PICKUP_ARRIVE',
//   PICKUP: 'PICKUP',
//   CANCEL: 'CANCEL',
//   DROP_FINISH: 'DROP_FINISH',
//   RESERVE_END: 'RESERVE_END',
//   WAIT: 'WAIT',
//   WAIT_END: 'WAIT_END',
//   SELF_DELIVERY: 'SELF_DELIVERY',
//   RESERVE: 'RESERVE',
// } as const;
class OrderApi extends Requestor {
    getOrderList(params = {}) {
        return this.get({
            url: '/api/v1/orders',
            params,
        });
    }
    getOrder(orderId, params = {}) {
        return this.get({
            url: `/api/v1/orders/${orderId}`,
            params,
        });
    }
    /**
     * 주문 이벤트 발생 API
     * https://qc-zoo-client-api.barogo.io/docs/api-guide.html#_5_11_%EC%A3%BC%EB%AC%B8_%EC%9D%B4%EB%B2%A4%ED%8A%B8_%EB%B0%9C%EC%83%9D_api
     */
    postOrderEvent(orderId, data) {
        return this.post({
            url: `/api/v1/orders/${orderId}/event`,
            data,
        });
    }
    getGoods(orderId, params = {}) {
        return this.get({
            url: `/api/v1/orders/${orderId}/goods`,
            params,
        });
    }
    getPayments(orderId, params = {}) {
        return this.get({
            url: `/api/v1/orders/${orderId}/payments`,
            params,
        });
    }
    putPaymentsInfo(orderId, data = {}) {
        return this.put({
            url: `/api/v1/orders/${orderId}/payment-info`,
            data,
        });
    }
    putPickupWishAt(orderId, data = {}) {
        return this.put({
            url: `/api/v1/orders/${orderId}/pickup-wish-at`,
            data,
        });
    }
    postPickupDelayWishAt(orderId, data = {}) {
        return this.post({
            url: `/api/v1/orders/${orderId}/pickup-delay`,
            data,
        });
    }
    putAdjustDeliveryAmount(orderId, data = {}) {
        return this.put({
            url: `/api/v1/orders/${orderId}/delivery-amount`,
            data,
        });
    }
    putDropInfo(orderId, data = {}) {
        return this.put({
            url: `/api/v1/orders/${orderId}/drop-info`,
            data,
        });
    }
    getOrderHistory(orderId, params = {}) {
        return this.get({
            url: `/api/v1/orders/${orderId}/history`,
            params,
        });
    }
    // 라이더 지원금
    putWorkerSupportAmount(orderId, data = {}) {
        return this.put({
            url: `/api/v1/orders/${orderId}/worker-support-amount`,
            data,
        });
    }
    postBaromoneyRemittance(orderId, data = {}) {
        return this.post({
            url: `/api/v1/orders/${orderId}/baromoney-remittance`,
            data,
        });
    }
    // 배달내역건 조회 (완료된 주문을 배달내역이라는 페이지에서 호출한다.)
    // 배달내역 === 완료된 주문 (정상완료, 취소 모두 포함)
    getOrderListByDone(params = {}) {
        return this.get({
            url: '/api/v1/orders/done',
            params,
        });
    }
    // 지도관제 주문 조회
    getOrderListByProcess(params = {}) {
        return this.get({
            url: '/api/v1/orders/process',
            params,
        });
    }
    /**
     * 라이더 수행상황 조회
     * https://qc-zoo-client-api.barogo.io/docs/api-guide.html#_5_31_%EB%9D%BC%EC%9D%B4%EB%8D%94_%EC%88%98%ED%96%89%EC%83%81%ED%99%A9_%EC%A1%B0%ED%9A%8C
     */
    getOrderByWorkerCode(params = {}) {
        return this.get({
            url: '/api/v1/orders/process-by-worker',
            params,
        });
    }
}
export default new OrderApi(clientInstance);
